export default {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  videos: state => state.videos.videos,
  currentVideo: state => state.videos.currentVideo,
  // overlay modal getters
  modal: state => state.app.modal,
  // validation banner
  validationBanner: state => state.app.validationBanner,
  cookiesBanner: state => state.app.cookiesBanner,
  // Routes
  permission_routes: state => state.permissions.routes,
  addRoutes: state => state.permissions.addRoutes,
  // app scroller
  scroller: state => state.app.scroller
}
